declare const __APP_VERSION__: string;

export const serviceVersion = __APP_VERSION__;
